import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Environment } from 'src/environments/environment';

import { CropVariety, GetCropVarietiesResponse } from '../models';

@Injectable({
  providedIn: 'root',
})
export class CropVarietyService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = `${this.env.APIM_BASE_URL}/arable-service/cropvariety`;

  getCropVarietiesByCropIds(cropIds: number[]): Observable<CropVariety[]> {
    const uniqueCropIds = [...cropIds]
      .sort()
      .filter((item, pos, ary) => !pos || item !== ary[pos - 1]);
    return this.http
      .get<GetCropVarietiesResponse>(
        `${this.baseUrl}/cropids?${this.getParamString('cropIds', uniqueCropIds)}`,
      )
      .pipe(map(({ cropVarieties }) => cropVarieties));
  }

  getParamString(key: string, values: number[] | string[]) {
    let paramString = '';
    values.forEach((value: number | string) => {
      paramString += `&${key}=${value}`;
    });
    return paramString.substring(1);
  }
}
